/**
 * Чтобы не было повторений, всю js-логику собрал в одном файле
 * pages/cart/init.js
 */
import './init';
